<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <OnValidationList :fss=fss :rliss="rliss" ></OnValidationList>
      </div>
    </div>
  </div>
</template>

<script>

// Ce fichier est encore en développement, et non utilisé

import OnValidationList from '@/components/OnValidationList.vue'
import axios from 'axios';

export default {
  data: function() {return {
    fss: [],
    rliss: []
  }},

  name: 'OnValidation',
  components: {
    OnValidationList,
  },
  methods: {
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/validation.php',
          { })
        .then(response => {
          this.fss = response.data.fss;
          this.rliss = response.data.rliss;
        })
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>
